var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title != null)?_c('div',{staticClass:"text-center font-weight-bold text-h6 mb-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('Bar',{staticStyle:{"height":"350px"},attrs:{"chartOptions":_vm.chart_options,"chartData":_vm.chart_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }